import { SubStatus } from "core-integration/src/store/my-team/types";
import { rgba } from "polished";
import styled, { css } from "styled-components";
import Table from "./Table";

interface IProps {
  elementType?: number;
}

export const ElementTable = styled(Table)<IProps>`
  width: 100%;
  white-space: nowrap;
  table-layout: fixed;
  background-color: white;
  border-collapse: collapse;

  th,
  td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  thead th {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
  }

  thead {
    border-left: ${({ theme }) => theme.borders[1]};
    border-right: ${({ theme }) => theme.borders[1]};
  }

  th {
    border-top: ${({ theme }) => theme.borders[1]};
    border-bottom: 0;
  }
`;

export const PrimaryCell = styled.td`
  position: relative;
  text-align: center;
`;

interface IElementRowProps {
  variant?: SubStatus;
}

export const ElementRow = styled.tr<IElementRowProps>`
  td:first-child {
    padding: 0.2rem;
  }

  ${(props) =>
    props.variant === "instigator" &&
    css`
      background-color: ${rgba("yellow", 0.6)};
    `}

  ${(props) =>
    props.variant === "target" &&
    css`
      background-color: ${rgba("#f60", 0.6)};
    `}

  ${(props) =>
    props.variant === "invalid" &&
    css`
      opacity: 0.6;
    `}
`;

interface IElementCellProps {
  bold?: boolean;
}

export const ElementCell = styled.td<IElementCellProps>`
  position: relative;
`;
